import type {Reviewer} from '../../../../../page-data/payloads/review-requests'
import {ReviewerIdentity} from '../../../reviewers/ReviewerIdentity'

export function ReviewerLink({reviewer}: {reviewer: Reviewer}) {
  return <ReviewerIdentity reviewer={reviewer} withAvatar={false} withLeadingAt />
}
